export const BOOKING_SHIPMENTS_ROUTE_PREFIX: string = '/dashboard/booking-shipments';

interface BookingShipmentsRoutes {
  details: {
    getUrl: (id: string, tab?: string) => string;
    path: string;
    relativePath: string;
  };
}

const bookingShipmentsRoutes: BookingShipmentsRoutes = {
  details: {
    path: `${BOOKING_SHIPMENTS_ROUTE_PREFIX}/details/:id/:tab?`,
    getUrl: (id: string, tab?: string): string => {
      const url: string = `${BOOKING_SHIPMENTS_ROUTE_PREFIX}/details/${id}`;

      if (!tab) {
        return url;
      }

      return `${url}/${tab}`;
    },
    relativePath: 'booking-shipments/details/:id/:tab?'
  }
};

export default bookingShipmentsRoutes;
